export default __webpack_public_path__ + "maps-examples-live-data-thumbnail-480-bbbb0dcd9dccc4bb6f9c0569dbc1b39b.webp";